import React from 'react';
import styles from './Shimmer.module.css';

interface ShimmerProps {
  type?: 'card' | 'list' | 'text' | 'table';
  count?: number;
}

const Shimmer: React.FC<ShimmerProps> = ({ type = 'card', count = 1 }) => {
  const renderShimmer = () => {
    switch (type) {
      case 'card':
        return <ShimmerCard />;
      case 'list':
        return <ShimmerList />;
      case 'text':
        return <ShimmerText />;
      case 'table':
        return <ShimmerTable />;
      default:
        return <ShimmerCard />;
    }
  };

  return (
    <div className={styles.shimmerContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>{renderShimmer()}</div>
      ))}
    </div>
  );
};

const ShimmerCard: React.FC = () => (
  <div className={styles.shimmerCard}>
    <div className={`${styles.shimmerLine} ${styles.title}`}></div>
    <div className={`${styles.shimmerLine} ${styles.subtitle}`}></div>
    <div className={styles.shimmerContent}>
      <div className={styles.shimmerLine}></div>
      <div className={styles.shimmerLine}></div>
      <div className={styles.shimmerLine}></div>
    </div>
  </div>
);

const ShimmerList: React.FC = () => (
  <div className={styles.shimmerList}>
    {[1, 2, 3].map((item) => (
      <div key={item} className={styles.shimmerListItem}>
        <div className={styles.shimmerCircle}></div>
        <div className={styles.shimmerListContent}>
          <div className={`${styles.shimmerLine} ${styles.short}`}></div>
          <div className={`${styles.shimmerLine} ${styles.shorter}`}></div>
        </div>
      </div>
    ))}
  </div>
);

const ShimmerText: React.FC = () => (
  <div className={styles.shimmerText}>
    <div className={styles.shimmerLine}></div>
    <div className={`${styles.shimmerLine} ${styles.short}`}></div>
  </div>
);

const ShimmerTable: React.FC = () => (
  <div className={styles.shimmerTable}>
    <div className={styles.shimmerTableHeader}>
      <div className={styles.shimmerLine}></div>
      <div className={styles.shimmerLine}></div>
      <div className={styles.shimmerLine}></div>
    </div>
    {[1, 2, 3, 4, 5].map((row) => (
      <div key={row} className={styles.shimmerTableRow}>
        <div className={styles.shimmerLine}></div>
        <div className={styles.shimmerLine}></div>
        <div className={styles.shimmerLine}></div>
      </div>
    ))}
  </div>
);

export default Shimmer;